import { Card, Col, Row } from "antd";
import React, { Fragment } from "react";
import { Attachment } from "../helpers/shared-interfaces";

type AttachementsWithDisplayName = Attachment & { displayName: string };

interface Props {
  attachments: AttachementsWithDisplayName[];
  alignVertical?: boolean;
  attachmentName?: string;
}

export default class AttachmentsDisplay extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <Fragment>
        <div>
          <Row gutter={[8, 8]}>
            {this.props.attachments?.map(
              (attachment: AttachementsWithDisplayName, index: number) => {
                const url = attachment.url.includes("http")
                  ? attachment.url
                  : `//${attachment.url}`;
                return (
                  <Col
                    span={this.props.alignVertical ? 24 : 8}
                    key={attachment.id}
                    style={{
                      marginBottom: "18px",
                    }}
                  >
                    <Card>
                      <p>{attachment.displayName}</p>
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        View {this.props?.attachmentName ?? "Attachment"}
                      </a>
                    </Card>
                  </Col>
                );
              },
            )}
          </Row>
        </div>
      </Fragment>
    );
  }
}
